var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex justify-between" };
const _hoisted_2 = { class: "flex items-center space-x-2" };
const _hoisted_3 = {
    key: 0,
    class: "max-h-[350px] overflow-y-auto"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = { class: "flex items-center justify-between" };
const _hoisted_6 = { class: "flex items-center space-x-3" };
const _hoisted_7 = { key: 1 };
const _hoisted_8 = { class: "flex justify-center my-5" };
const _hoisted_9 = { class: "flex items-center text-sm" };
const _hoisted_10 = {
    key: 1,
    class: "mt-5"
};
import { ArrowLeftIcon, ChevronRightIcon, FolderClosedIcon, FolderIcon, XIcon, } from '@gohighlevel/ghl-icons/24/outline';
import { UIButton, UIForm, UIModal, UIModalContent, UIModalFooter, UIModalHeader, UITextMdMedium, UITextSmMedium, } from '@gohighlevel/ghl-ui';
import { truncate } from 'lodash';
import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import useEmitter from '../composable/useEmitter';
import { useEvent } from '../composable/useEvent';
import MediaService from '../services/MediaService';
import { useStore } from '../store';
import FormInputItem from './FormInputItem.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'MoveItemModal',
    setup(__props) {
        const rules = {
            folderName: {
                required: true,
                validator: (_, value) => {
                    var _a;
                    if (!((_a = value === null || value === void 0 ? void 0 : value.trim) === null || _a === void 0 ? void 0 : _a.call(value))) {
                        return new Error(t('common.folderNameValidation'));
                    }
                    return new Promise(res => res(value));
                },
                trigger: ['input', 'blur'],
            },
        };
        const { sendNotification } = useEvent();
        const { t } = useI18n();
        const formValue = ref({ folderName: '' });
        const formRef = ref(null);
        const open = ref(false);
        const emitter = useEmitter();
        const selectedItem = ref();
        const store = useStore();
        const onMove = ref(false);
        const createFolderProcessing = ref(false);
        const createFolderActive = ref(false);
        const parentFolder = ref();
        const foldersList = ref();
        const heading = ref();
        const parentsTrack = ref([]);
        const fetching = ref(true);
        const alreadyHere = computed(() => {
            if (selectedItem.value) {
                if (parentFolder.value) {
                    return selectedItem.value.parentId === parentFolder.value._id
                        ? true
                        : false;
                }
                else {
                    return selectedItem.value.parentId ? false : true;
                }
            }
            else {
                return true;
            }
        });
        onMounted(() => {
            emitter.on('moveItem', (item) => __awaiter(this, void 0, void 0, function* () {
                parentFolder.value = null;
                open.value = true;
                selectedItem.value = item;
                heading.value = t('common.home');
                foldersList.value = yield getFolders();
            }));
        });
        function getFolders() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    fetching.value = true;
                    const { data } = yield MediaService.listFiles({
                        altId: store.altId,
                        altType: store.altType,
                        parentId: parentFolder.value ? parentFolder.value._id : '',
                        deleted: false,
                        type: 'folder',
                        sortBy: 'name',
                    });
                    fetching.value = false;
                    return data.files;
                }
                catch (error) {
                    console.error(error);
                }
            });
        }
        function goBack() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    if (createFolderActive.value) {
                        closeFolderCreate();
                        return;
                    }
                    parentFolder.value = parentsTrack.value.pop();
                    foldersList.value = yield getFolders();
                }
                catch (error) {
                    console.error(error);
                }
            });
        }
        function setFolder(folder) {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    if ((_a = parentFolder === null || parentFolder === void 0 ? void 0 : parentFolder.value) === null || _a === void 0 ? void 0 : _a._id) {
                        parentsTrack.value.push(parentFolder.value);
                    }
                    else {
                        parentsTrack.value.push({ _id: null, name: 'Home' });
                    }
                    parentFolder.value = folder;
                    foldersList.value = yield getFolders();
                }
                catch (error) {
                    console.error(error);
                }
            });
        }
        function onclickMove() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    onMove.value = true;
                    yield MediaService.moveFile({
                        fileId: selectedItem.value._id,
                        altId: store.altId,
                        altType: store.altType,
                        targetParentId: parentFolder.value ? parentFolder.value._id : '',
                    });
                    emitter.emit('updateUI');
                    onMove.value = false;
                    open.value = false;
                    foldersList.value = [];
                    sendNotification({
                        type: 'success',
                        title: t('common.successfullyMovedFile'),
                    });
                }
                catch (error) {
                    console.error(error);
                    onMove.value = false;
                    open.value = false;
                    foldersList.value = [];
                    sendNotification({
                        type: 'success',
                        title: t('common.FailedToMoveFile'),
                    });
                }
            });
        }
        function createNewFolder() {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    createFolderProcessing.value = true;
                    yield ((_a = formRef.value) === null || _a === void 0 ? void 0 : _a.getForm().validate());
                    const { data } = yield MediaService.createFolder({
                        name: formValue.value.folderName,
                        parentId: parentFolder.value ? parentFolder.value._id : '',
                        altId: store.altId,
                        altType: store.altType,
                    });
                    yield setFolder(data);
                    emitter.emit('updateUI');
                    closeFolderCreate();
                }
                catch (error) {
                    console.error(error);
                }
                finally {
                    createFolderProcessing.value = false;
                }
            });
        }
        function closeFolderCreate() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    createFolderActive.value = false;
                    formValue.value.folderName = '';
                }
                catch (error) {
                    console.error(error);
                }
            });
        }
        function onClickClose() {
            open.value = false;
            formValue.value.folderName = '';
            foldersList.value = [];
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UIModal), {
                show: open.value,
                id: "modal"
            }, {
                header: _withCtx(() => [
                    _createVNode(_unref(UIModalHeader), {
                        id: "modal-header",
                        type: "primary"
                    }, {
                        customHeader: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, [
                                _createElementVNode("div", _hoisted_2, [
                                    _createElementVNode("div", null, [
                                        ((parentFolder.value && parentFolder.value._id) || createFolderActive.value)
                                            ? (_openBlock(), _createBlock(_unref(ArrowLeftIcon), {
                                                key: 0,
                                                onClick: goBack,
                                                class: "w-5 h-5 cursor-pointer"
                                            }))
                                            : _createCommentVNode("v-if", true)
                                    ]),
                                    _createVNode(_unref(UITextMdMedium), null, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(truncate)(parentFolder.value && parentFolder.value.name
                                                ? parentFolder.value.name
                                                : `${_ctx.$t('common.home')}`, {
                                                length: 100,
                                            })), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _createVNode(_unref(XIcon), {
                                    onClick: onClickClose,
                                    class: "w-6 h-6 cursor-pointer opacity-80"
                                })
                            ])
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                footer: _withCtx(() => [
                    (!createFolderActive.value)
                        ? (_openBlock(), _createBlock(_unref(UIModalFooter), {
                            key: 0,
                            class: "mt-14",
                            positiveText: onMove.value ? `${_ctx.$t('common.moving')}` : `${_ctx.$t('common.moveHere')}`,
                            onPositiveClick: onclickMove,
                            id: "modal-footer",
                            loading: onMove.value,
                            disabled: onMove.value || alreadyHere.value
                        }, {
                            actionLeft: _withCtx(() => [
                                _createVNode(_unref(UIButton), {
                                    id: "createFolder",
                                    onClick: _cache[1] || (_cache[1] = ($event) => (createFolderActive.value = true))
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_unref(FolderIcon), { class: "w-4 h-4 mr-2" }),
                                        _createTextVNode(_toDisplayString(_ctx.$t('common.newFolder')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["positiveText", "loading", "disabled"]))
                        : (_openBlock(), _createBlock(_unref(UIModalFooter), {
                            key: 1,
                            positiveText: _ctx.$t('common.save'),
                            onPositiveClick: createNewFolder,
                            disabled: createFolderProcessing.value,
                            loading: createFolderProcessing.value,
                            id: "modal-footer"
                        }, null, 8 /* PROPS */, ["positiveText", "disabled", "loading"]))
                ]),
                default: _withCtx(() => [
                    _createVNode(_unref(UIModalContent), null, {
                        default: _withCtx(() => {
                            var _a, _b;
                            return [
                                (!createFolderActive.value)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        ((_a = foldersList.value) === null || _a === void 0 ? void 0 : _a.length)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(foldersList.value, (folder, index) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        key: index,
                                                        class: "p-2 text-gray-500 rounded cursor-pointer hover:text-gray-700 hover:bg-gray-100 group",
                                                        onClick: ($event) => (setFolder(folder))
                                                    }, [
                                                        _createElementVNode("div", _hoisted_5, [
                                                            _createElementVNode("div", _hoisted_6, [
                                                                _createElementVNode("div", null, [
                                                                    _createVNode(_unref(FolderIcon), {
                                                                        id: folder === null || folder === void 0 ? void 0 : folder._id,
                                                                        class: "w-5 h-5"
                                                                    }, null, 8 /* PROPS */, ["id"])
                                                                ]),
                                                                _createVNode(_unref(UITextSmMedium), { class: "truncate" }, {
                                                                    default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString(_unref(truncate)(folder === null || folder === void 0 ? void 0 : folder.name, {
                                                                            length: 50,
                                                                        })), 1 /* TEXT */)
                                                                    ]),
                                                                    _: 2 /* DYNAMIC */
                                                                }, 1024 /* DYNAMIC_SLOTS */)
                                                            ]),
                                                            _createVNode(_unref(ChevronRightIcon), { class: "invisible w-5 h-5 group-hover:visible" })
                                                        ])
                                                    ], 8 /* PROPS */, _hoisted_4));
                                                }), 128 /* KEYED_FRAGMENT */))
                                            ]))
                                            : (((_b = foldersList.value) === null || _b === void 0 ? void 0 : _b.length) == 0 && !fetching.value)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                                    _createElementVNode("div", _hoisted_8, [
                                                        _createVNode(_unref(FolderClosedIcon), { class: "w-5 h-5 mr-1" }),
                                                        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('common.noFolder')), 1 /* TEXT */)
                                                    ])
                                                ]))
                                                : _createCommentVNode("v-if", true)
                                    ], 64 /* STABLE_FRAGMENT */))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                        _createVNode(_unref(UIForm), {
                                            model: formValue.value,
                                            rules: rules,
                                            ref_key: "formRef",
                                            ref: formRef,
                                            id: "modal-form"
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(FormInputItem, {
                                                    modelValue: formValue.value.folderName,
                                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((formValue.value.folderName) = $event)),
                                                    itemId: "folderName",
                                                    itemLabel: _ctx.$t('common.folderName'),
                                                    itemPlaceholder: _ctx.$t('common.folderNameValidation')
                                                }, null, 8 /* PROPS */, ["modelValue", "itemLabel", "itemPlaceholder"])
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["model"])
                                    ]))
                            ];
                        }),
                        _: 1 /* STABLE */
                    })
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["show"]));
        };
    }
});
